import CardContainer from "../components/Cards/CardContainer";

export default function AllItems() {
  return (
    <div className="w-screen h-[90vh] bg-[#F5F5F5] overflow-y-scroll no-scrollbar">
      <div className="mt-10">
        <div className="flex justify-center text-[24px]">
          <h4 style={{ fontFamily: "ZapfHumanistBold" }}>
            Welcome to Collection Creator.
          </h4>
        </div>
        <div className="flex flex-col justify-center items-center">
          <div className="flex flex-col justify-center items-center text-[14px] text-center mt-2">
            <h1>Choose any item to begin designing!</h1>
          </div>{" "}
          <div className="text-[14px] py-2"></div>
        </div>
      </div>
      <div>
        <CardContainer />

        <div className="flex justify-center items-center mt-6">
          <div className="flex  flex-col lg:flex-row justify-center text-center gap-6 m-6 mb-8">
            <p
              className="text-[25px] text-[#04595a]"
              style={{ fontFamily: "AmalfiCoast" }}
            >
              Collection Creator
            </p>
            <div className="text-[19px] text-[#616160] flex gap-6">
              <div className="flex gap-2">
                <p>P</p>
                <p>A</p>
                <p>C</p>
                <p>K</p>
                <p>A</p>
                <p>G</p>
                <p>I</p>
                <p>N</p>
                <p>G</p>
              </div>
              <div className="flex gap-2">
                <p>D</p>
                <p>E</p>
                <p>S</p>
                <p>I</p>
                <p>G</p>
                <p>N</p>
                <p>E</p>
                <p>D</p>
              </div>
              <div className="flex gap-2">
                <p>B</p>
                <p>Y</p>
              </div>
            </div>
            <p
              className="text-[25px] text-[#04595a]"
              style={{ fontFamily: "AmalfiCoast" }}
            >
              You!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
